module.exports = __webpack_public_path__ + "static/media/DualShift.1698330f.svg";